import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import ProgrammingLanguages from "./ProgrammingLanguages";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import Frameworks from "./Framworks";
import Databases from "./Databases";
import OtherTechnologies from "./OtherTechnologies";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know Who <strong className="purple">I am</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
          Programming <strong className="purple">Languages </strong>
        </h1>

        <ProgrammingLanguages />

        <h1 className="project-heading">
          Frameworks & <strong className="purple">Libraries </strong>
        </h1>

        <Frameworks />

        <h1 className="project-heading">
          <strong className="purple">Databases </strong>
        </h1>

        <Databases />

        <h1 className="project-heading">
          <strong className="purple">Devops</strong> & Tools
        </h1>
        <Toolstack />

        <h1 className="project-heading">
          Other <strong className="purple">Technologies</strong>
        </h1>
        <OtherTechnologies />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
